import { Map } from 'immutable'
import 'store/types'

/**
 * @param {String} storeKey static store key
 * @returns {selectStaticTextByKey~selectFromState}
 */
export const selectStaticTextByKey = (storeKey) => {
  if (!storeKey) {
    throw new Error('The storeKey option is required.')
  }

  /**
   * @param {ReduxState} state redux state
   */
  const selectFromState = (state) => {
    return state.staticText.getIn(['data', storeKey, 'data'], Map())
  }

  return selectFromState
}
export default selectStaticTextByKey
